<template>
  <b-modal
    size="lg"
    id="new_resident_from_client"
    title="NOVO RESIDENTE"
    hide-footer
    no-close-on-backdrop
    @show="evOnShow"
    @shown="evOnShown"
    @hide="evOnHide"
  >
    <b-overlay :show="loading" opacity="0.99">
      <form @submit.prevent="evOnSubmit">
        <b-row>
          <b-col>
            <label>CLIENTE</label>
            <b-select v-model="client">
              <b-select-option value>SELECIONE</b-select-option>
              <b-select-option
                v-for="client in clients"
                :key="client.id"
                :value="client"
              >
                {{ client.name.toUpperCase() }}
              </b-select-option>
            </b-select>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <label-required-field label="Nome" />
            <input
              type="text"
              ref="autofocus"
              v-model="name"
              class="form-control"
            />
          </b-col>
          <b-col>
            <label>CPF</label>
            <BInputCPF v-model="cpf" />
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <label-required-field label="Data de nascimento" />
            <input type="date" v-model="date_of_birth" class="form-control" />
            <span>{{
              date_of_birth && date_of_birth.length == 10
                ? "Idade: " +
                  getAge(formatDateToUs(date_of_birth, true)) +
                  " anos"
                : ""
            }}</span>
          </b-col>
          <b-col>
            <label-required-field label="Gênero" />
            <select v-model="gender_id" class="form-control">
              <option value>SELECIONE...</option>
              <option
                v-for="value in genders"
                :key="value.id"
                :value="value.id"
              >
                {{ String(value.name).toUpperCase() }}
              </option>
            </select>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <label-required-field label="Grau de Dependência" />
            <select v-model="degree_of_dependence_id" class="form-control">
              <option value>SELECIONE...</option>
              <option
                v-for="item in degrees_of_dependence"
                :key="item.id"
                :value="item.id"
              >
                {{ item.name }}
              </option>
            </select>
          </b-col>
          <b-col>
            <label-required-field label="Status" />
            <select v-model="status_type_id" class="form-control">
              <option value>SELECIONE...</option>
              <option
                v-for="value in statusTypes"
                :key="value.id"
                :value="value.id"
              >
                {{ String(value.name).toUpperCase() }}
              </option>
            </select>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <label>Observações</label>
            <chrome-speech-to-text-textarea
              rows="4"
              max-rows="10"
              v-model="comments"
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <label>Endereço</label>
            <input type="text" v-model="address" class="form-control" />
          </b-col>
          <b-col>
            <label>Nº</label>
            <input type="text" v-model="number_address" class="form-control" />
          </b-col>
          <b-col>
            <label>Complemento</label>
            <input type="text" v-model="complement" class="form-control" />
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <label>CEP</label>
            <BInputCEP v-model="cep" @retrieved="evOnCEPRetrieved" />
          </b-col>
          <b-col>
            <label>Bairro</label>
            <input type="text" v-model="neighborhood" class="form-control" />
          </b-col>
          <b-col>
            <label>Cidade</label>
            <input type="text" v-model="city" class="form-control" />
          </b-col>
          <b-col>
            <label>Estado</label>
            <select v-model="uf_id" class="form-control">
              <option value>SELECIONE...</option>
              <option v-for="value in ufs" :key="value.id" :value="value.id">
                {{ value.name }}
              </option>
            </select>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <warning-required-fields />
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <errors-messages :errors="errors" />
          </b-col>
        </b-row>
        <b-row align-h="end">
          <b-col cols="auto">
            <v-btn :disabled="loading" type="submit" class="btn-save">
              <i class="fas fa-save mr-2 text-twenty"></i>
              {{ loading ? "Carregando" : "SALVAR" }}
            </v-btn>
          </b-col>
        </b-row>
      </form>
    </b-overlay>
  </b-modal>
</template>

<script>
import api from "../../services/api";
import ChromeSpeechToTextTextarea from "../Components/ChromeSpeechToTextTextarea.vue";
import ErrorsMessages from "../Components/ErrorsMessages.vue";
import LabelRequiredField from "../Components/LabelRequiredField.vue";
import WarningRequiredFields from "../Components/WarningRequiredFields.vue";
import permission from "../../lib/permission";
import { formatValueOnKeyUp, formatPrice, numbersOnly } from "../../lib/format";
import toast from "../../lib/ToastNotification";
import { getAge } from "../../lib/getAgeByDate";
import { formatDateToUs } from "../../lib/format";
import BInputCEP from "../Components/BInputCEP.vue";
import BInputCPF from "../Components/BInputCPF.vue";

export default {
  name: "NewResidentFromClient",

  components: {
    ChromeSpeechToTextTextarea,
    LabelRequiredField,
    WarningRequiredFields,
    ErrorsMessages,
    BInputCEP,
    BInputCPF,
  },

  props: {},

  data() {
    return {
      errors: [],
      loading: false,

      clients: [],
      genders: [],
      degrees_of_dependence: [],
      statusTypes: [],
      ufs: [],

      client: "",

      client_id: "",
      name: "",
      cpf: "",
      date_of_birth: "",
      gender_id: "",
      degree_of_dependence_id: "",
      status_type_id: "",
      comments: "",

      address: "",
      number_address: "",
      complement: "",
      cep: "",
      neighborhood: "",
      city: "",
      uf_id: "",
    };
  },

  created() {
    this.evOnCreated();
  },

  watch: {
    async client() {
      const valid = this.client ? true : false;

      let cpf = "";
      let comments = "";

      if (valid) {
        if (this.client.cpf_cnpj)
          if (numbersOnly(this.client.cpf_cnpj).length === 11)
            cpf = this.client.cpf_cnpj;

        if (this.client.note) comments = this.client.note;
      }

      this.client_id = valid ? this.client.id : "";
      this.name = valid ? this.client.name : "";
      this.cpf = cpf;
      this.date_of_birth = "";
      this.gender_id = "";
      this.degree_of_dependence_id = "";
      this.status_type_id = "";
      this.comments = comments;

      this.address = valid ? this.client.address : "";
      this.number_address = valid ? this.client.address_number : "";
      this.complement = valid ? this.client.complement : "";
      this.cep = valid ? this.client.cep : "";
      this.neighborhood = valid ? this.client.neighborhood : "";
      this.city = valid ? this.client.city : "";
      this.uf_id = valid ? this.client.uf_id : "";
    },
  },

  methods: {
    permission,
    formatPrice,
    getAge,
    formatDateToUs,

    async evOnCreated() {
      if (this.errors.length === 0) await this.getGenders();
      if (this.errors.length === 0) await this.getDegreesOfDependence();
      if (this.errors.length === 0) await this.getStatusResidents();
      if (this.errors.length === 0) await this.getUfs();
    },

    async evOnShow() {
      this.loading = false;
      this.errors = [];
      this.client = "";
      if (this.errors.length === 0) await this.getNonResidentClients();
    },

    async evOnShown() {
      this.$refs.autofocus.focus();
    },

    async evOnHide() {},

    async evOnSubmit() {
      try {
        this.loading = true;

        const data = {
          client_id: this.client_id,
          name: this.name,
          cpf: this.cpf,
          gender_id: this.gender_id,
          date_of_birth: this.date_of_birth,
          degree_of_dependence_id: this.degree_of_dependence_id,
          status_type_id: this.status_type_id,
          comments: this.comments,

          address: this.address,
          number_address: this.number_address,
          complement: this.complement,
          cep: this.cep,
          neighborhood: this.neighborhood,
          city: this.city,
          uf_id: this.uf_id,
        };
        const response = await api.post("/rest-home/resident", data);
        const { error, errors, resident_id } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.$router.push({
            name: "resident",
            params: { id: resident_id },
            query: {
              tab: "informations",
              action: "geral",
            },
          });
          this.$emit("created");
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async getGenders() {
      try {
        const response = await api.get("/genders");
        const { error, errors, genders } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.genders = genders;
        }
      } catch (error) {
        console.log(error);
      }
    },

    async getNonResidentClients() {
      try {
        this.loading = true;

        const response = await api.get(
          "/rest-home/financial/non-resident-clients"
        );
        const { error, errors, clients } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.clients = clients;
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },

    async getDegreesOfDependence() {
      try {
        this.loading = true;

        const response = await api.get("/default/degrees-of-dependence");
        const { error, errors, degrees_of_dependence } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.degrees_of_dependence = degrees_of_dependence;
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },

    async getStatusResidents() {
      try {
        const { rest_home_id } = this;

        let params = {
          rest_home_id,
          type: "RESIDENTE",
        };

        const response = await api.get("/rest-home/type/status/all", {
          params,
        });

        const { error, errors, status } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.statusTypes = status;
        }
      } catch (error) {
        console.log(error);
      }
    },

    async getUserProfiles() {
      try {
        const response = await api.get("/rest-home/profiles");

        const { error, errors, profiles } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          var array = [];

          for (let i = 0; i < profiles.length; i++) {
            var obj = {
              id: profiles[i].id,
              value: profiles[i].id,
              text: String(profiles[i].name).toUpperCase(),
            };

            array.push(obj);
          }

          this.profiles = array;
        }
      } catch (error) {
        console.log(error);
      }
    },

    async getUfs() {
      try {
        const response = await api.get("/ufs");

        const { error, errors, ufs } = response.data;
        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.ufs = ufs;
        }
      } catch (error) {
        console.log(error);
      }
    },

    async getBillingTypeOfHostingTypes() {
      try {
        const response = await api.get("/rest-home/type-of-hosting/types");

        const { error, errors, types } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.billing_type_of_hosting_types = types;
        }
      } catch (error) {
        console.log(error);
      }
    },

    async evOnCEPRetrieved(value) {
      this.cep = value.cep;
      this.city = value.localidade || this.city;
      this.neighborhood = value.bairro || this.neighborhood;
      // this.complement = value.complemento || this.complement;
      this.address = value.logradouro || this.address;

      const matched_uf = this.ufs.find(
        (item) => item.initials.toLowerCase() === value.uf.toLowerCase()
      );
      if (matched_uf) this.uf_id = matched_uf.id;
    },

    async evOnPhotoSelected() {
      try {
        this.loading = true;
        this.errors = [];

        if (!this.photo) {
          this.photo = null;
          this.errors.push("Informe a foto");
          this.loading = false;
          return;
        }

        const allowedMimes = [
          "image/jpg",
          "image/jpeg",
          "image/pjpeg",
          "image/png",
        ];

        if (!allowedMimes.includes(this.photo.type)) {
          this.photo = null;
          this.errors.push("Formato de arquivo inválido");
          this.loading = false;
          return;
        }

        var limitSize = 10 * 1024 * 1024;

        if (this.photo.size > limitSize) {
          this.photo = null;
          this.errors.push("Suportado até 10MB");
          return;
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },

    async uploadPhoto(resident_id) {
      try {
        const formData = new FormData();
        formData.append("id", resident_id);
        formData.append("photo", this.photo, this.photo.name);

        const response = await api.post("/rest-home/resident/photo", formData);
        const { error } = response.data;

        if (error) toast("Não foi possível definir a foto", "success");
      } catch (error) {
        console.log(error);
      }
    },

    handleValueINSSBenefitAmount: function (e) {
      this.INSS_benefit_amount = formatValueOnKeyUp(e.target.value);
    },
  },
};
</script>

<style>
</style>